import { useEffect, useState } from "react";
import {
  InfoCardNewAdv,
  InfoTimeCardAdv,
  PageHeader,
  PageTitle,
  StatusTags,
  TableAdv,
} from "../../../../../components";
import { dateFormator, mapTableRows } from "../../../../../utils";
import { formatCurrency } from "../../../../../utils/stringUtils";
import { useSelector } from "react-redux";
import axiosRequest from "../../../../../redux/slices/universal/axiosService";
import { ENDPOINTS } from "../../../../../redux/apiConfig";
import { usePagination } from "../../../../../hooks";
import { RecordStatus } from "../../../../../assets/data/enumData";

const Adjustments = () => {
  const { employeeProfileUiid } = useSelector((state) => state?.employee);
  const [adjustments, setAdjustments] = useState({
    short: [],
    excess: [],
    shortDiff: 0,
    excessDiff: 0,
  });
  const { page, limit, setPage, handleLimitChange } = usePagination(25);
  const ShortColumns = [
    {
      key: "jobTitle",
      label: "Job Title",
      render: (row) => <span>{row?.jobId?.jobInfo?.jobTitle}</span>,
    },
    {
      key: "clientName",
      label: "Client Name",
      render: (row) => <span>{row?.clientId?.businessName}</span>,
    },
    {
      key: "status",
      label: "Status",
      render: (row) => (
        <StatusTags
          tag={RecordStatus.find((list) => list.value === row.status).label}
        />
      ),
      sortable: false,
    },
    {
      key: "period",
      label: "Period",
      render: (row) => (
        <span>
          {dateFormator(row?.period?.from)} - {dateFormator(row?.period?.to)}
        </span>
      ),
    },
    {
      key: "originalHours",
      label: "Original Hours",
      render: (row) => (
        <span>
          {isNaN(row?.hours?.original)
            ? "-"
            : Number(row?.hours?.original).toFixed(2)}
        </span>
      ),
    },
    {
      key: "revisedHours",
      label: "Revised Hours",
      render: (row) => (
        <span>
          {isNaN(row?.hours?.revised)
            ? "-"
            : Number(row?.hours?.revised).toFixed(2)}
        </span>
      ),
    },
    {
      key: "originalPay",
      label: "Original Pay",
      render: (row) => <span>{formatCurrency(row?.pay?.original)}</span>,
    },
    {
      key: "revisedPay",
      label: "Revised Pay",
      render: (row) => <span>{formatCurrency(row?.pay?.revised)}</span>,
    },
    {
      key: "difference",
      label: "Difference",
      render: (row) => (
        <span>{formatCurrency(row?.pay?.original - row?.pay?.revised)}</span>
      ),
    },
    {
      key: "paymentStatus",
      label: "Status",
      render: (row) => <span>{row?.usage ? "Paid" : "Pending"}</span>,
    },

    // {
    //   key: "actions",
    //   label: "Actions",
    //   render: (row) => (
    //     <div className="flex items-center gap-2 flex-row">
    //       <Button
    //         type="icon"
    //         icon="visibility"
    //         size="xs"
    //         variant="text"
    //         color="black"
    //       />

    //       <Button
    //         type="icon"
    //         icon="delete"
    //         size="xs"
    //         variant="text"
    //         color="black"
    //       />
    //     </div>
    //   ),
    // },
  ];

  const Excesscolumns = [
    {
      key: "jobTitle",
      label: "Job Title",
      render: (row) => <span>{row?.jobId?.jobInfo?.jobTitle}</span>,
    },
    {
      key: "clientName",
      label: "Client Name",
      render: (row) => <span>{row?.clientId?.businessName}</span>,
    },
    {
      key: "status",
      label: "Status",
      render: (row) => (
        <StatusTags
          tag={RecordStatus.find((list) => list.value === row.status).label}
        />
      ),
      sortable: false,
    },
    {
      key: "period",
      label: "Period",
      render: (row) => (
        <span>
          {dateFormator(row?.period?.from)} - {dateFormator(row?.period?.to)}
        </span>
      ),
    },
    {
      key: "originalHours",
      label: "Original Hours",
      render: (row) => <span>{row?.hours?.original}</span>,
    },
    {
      key: "revisedHours",
      label: "Revised Hours",
      render: (row) => <span>{row?.hours?.revised}</span>,
    },
    {
      key: "originalPay",
      label: "Original Pay",
      render: (row) => <span>{formatCurrency(row?.pay?.original)}</span>,
    },
    {
      key: "revisedPay",
      label: "Revised Pay",
      render: (row) => <span>{formatCurrency(row?.pay?.revised)}</span>,
    },
    {
      key: "difference",
      label: "Difference",
      render: (row) => (
        <span>{formatCurrency(row?.pay?.original - row?.pay?.revised)}</span>
      ),
    },
    {
      key: "paymentStatus",
      label: "Status",
      render: (row) => <span>{row?.usage ? "Paid" : "Pending"}</span>,
    },

    // {
    //   key: "actions",
    //   label: "Actions",
    //   render: (row) => (
    //     <div className="flex items-center gap-2 flex-row">
    //       <Button
    //         type="icon"
    //         icon="visibility"
    //         size="xs"
    //         variant="text"
    //         color="black"
    //       />

    //       <Button
    //         type="icon"
    //         icon="delete"
    //         size="xs"
    //         variant="text"
    //         color="black"
    //       />
    //     </div>
    //   ),
    // },
  ];

  useEffect(() => {
    const fetchAdjustments = async () => {
      const [
        shortAdjustments,
        excessAdjustments,
        shortTotalDiff,
        excessTotalDiff,
      ] = await Promise.allSettled([
        axiosRequest({
          method: "GET",
          url: ENDPOINTS.EMPLOYEE_ADJUSTMENTS.GET_ALL,
          params: {
            coll: "EmpAdjustment",
            ref: "Placement Client",
            incl: ["jobInfo", "businessName"],
            lim: limit,
            pg: page,
            fil: JSON.stringify({
              employeeId: { type: "NONE", value: employeeProfileUiid },
              type: { type: "NONE", value: 1 },
            }),
          },
        }),
        axiosRequest({
          method: "GET",
          url: ENDPOINTS.EMPLOYEE_ADJUSTMENTS.GET_ALL,
          params: {
            coll: "EmpAdjustment",
            ref: "Placement Client",
            incl: ["jobInfo", "businessName"],
            lim: limit,
            pg: page,
            fil: JSON.stringify({
              employeeId: { type: "NONE", value: employeeProfileUiid },
              type: { type: "NONE", value: 2 },
            }),
          },
        }),
        axiosRequest({
          method: "GET",
          url: ENDPOINTS.EMPLOYEE_ADJUSTMENTS.GET_ALL,
          params: {
            useAggregate: true,
            coll: "EmpAdjustment",
            fil: JSON.stringify({
              adjustments: {
                type: "AG_STATS",
                value: [employeeProfileUiid, 1],
              },
            }),
          },
        }),
        axiosRequest({
          method: "GET",
          url: ENDPOINTS.EMPLOYEE_ADJUSTMENTS.GET_ALL,
          params: {
            useAggregate: true,
            coll: "EmpAdjustment",
            fil: JSON.stringify({
              adjustments: {
                type: "AG_STATS",
                value: [employeeProfileUiid, 2],
              },
            }),
          },
        }),
      ]);

      setAdjustments({
        short: shortAdjustments?.value,
        excess: excessAdjustments?.value,
        shortDiff: shortTotalDiff?.value,
        excessDiff: excessTotalDiff?.value,
      });
    };
    if (employeeProfileUiid) fetchAdjustments();
  }, [limit, page]);

  const mappedShortRows = adjustments.short?.success
    ? mapTableRows(adjustments?.short?.data?.data, ShortColumns)
    : [];
  const mappedExcessRows = adjustments.excess?.success
    ? mapTableRows(adjustments?.excess?.data?.data, Excesscolumns)
    : [];

  return (
    <div className="px-4 py-2 border-[1px] border-neutrals-50 rounded min-h-[73vh]">
      <div>
        <PageHeader
          Section={
            <div className="flex">
              <PageTitle title={"Short Payments"} />
            </div>
          }
          RightSection={
            <div>
              {/* <InfoTimeCardAdv
                title="Short Payments"
                value={formatCurrency(
                  adjustments?.shortDiff?.data?.data?.[0]?.diffTotal || 0,
                )}
                // prefix="$"
                suffix=""
                color="danger"
                size="sm"
              /> */}
              <InfoCardNewAdv
                title="Short Payments"
                value={formatCurrency(
                  adjustments?.shortDiff?.data?.data?.[0]?.diffTotal || 0,
                )}
                layout="option12"
                valueConfig={{ className: "text-[24px] text-danger!" }}
              />
            </div>
          }
        />
      </div>
      <div>
        <div className="mt-4">
          <TableAdv
            tableId={`employee_payments_adjustments1`}
            rows={mappedShortRows}
            columns={ShortColumns}
            // toolbarRight={[{ filterButton: false }, { DropdownMenu: false }]}
            hideToolBar
          />
        </div>
      </div>

      <div className="mt-4">
        <PageHeader
          Section={
            <div className="flex">
              <PageTitle title={"Excess Payments"} />
            </div>
          }
          RightSection={
            <div>
              {/* <InfoTimeCardAdv
                title="Excess Payments"
                value={`(${formatCurrency(adjustments?.excessDiff?.data?.data?.[0]?.diffTotal || 0)})`}
                // prefix="$"
                suffix=""
                color="success"
                size="sm"
              /> */}
              <InfoCardNewAdv
                title="Excess Payments"
                value={`(${formatCurrency(adjustments?.excessDiff?.data?.data?.[0]?.diffTotal || 0)})`}
                layout="option12"
                valueConfig={{ className: "text-[24px] text-success!" }}
              />
            </div>
          }
        />
      </div>
      <div className="mt-4">
        <TableAdv
          tableId={`employee_payments_adjustments2`}
          rows={mappedExcessRows}
          columns={Excesscolumns}
          // toolbarRight={[{ filterButton: false }, { DropdownMenu: false }]}
          hideToolBar
        />
      </div>
    </div>
  );
};

export default Adjustments;
